import React, { useState } from 'react'
import Loader from '@/components/Loader'
import CustomPageNavigator from '@/components/Pagination'
import MobileContactDetailsModel from './component/DetailModal'
import MobileFormConfirmationModal from './component/MobileFormConfirmationModal'
import useTicketList from './services/hooks/useTicketList'
import useCloseTicket from './services/hooks/usePutMarkTicket'
import { supportType } from './services/types/APIResponseType'
import { ApiStatusConstants } from '@/utils/config/auth-enums'
import TicketTable from './component/TicketTable'
import DataUnavailable from '@/components/DataUnavailable'

const MobileContactForm: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<number>(1)
  const itemsPerPage = 5
  const [open, setOpen] = React.useState<boolean>(false)
  const [userInfo, setUserInfo] = React.useState<supportType | null>(null)
  const [openConfirmation, setOpenConfirmation] = React.useState(false)
  const [updateData, setUpdateData] = useState(true)
  const [, setErrorMsg] = useState<string>('')
  const [, setApiStatus] = useState<ApiStatusConstants>(
    ApiStatusConstants.INITIAL,
  )
  const { data: ticketList, isLoading } = useTicketList(
    currentPage,
    itemsPerPage,
    updateData,
  )
  const { mutate: CloseTicket } = useCloseTicket()
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const handleMarkClosed = () => {
    setApiStatus(ApiStatusConstants.LOADING)
    CloseTicket(
      {
        payload: {
          ticketId: userInfo?._id,
        },
      },
      {
        onSuccess: () => {
          setApiStatus(ApiStatusConstants.SUCCESS)
          setUpdateData(true)
        },
        onError: (error) => {
          setApiStatus(ApiStatusConstants.FAILURE)
          setErrorMsg(
            error.message || 'Something went wrong. Please try again.',
          )
          setUpdateData(false)
        },
      },
    )
    setOpenConfirmation(false)
    setUpdateData(false)
  }

  if (isLoading) {
    return <Loader />
  }

  return (
    <div>
      {open && (
        <MobileContactDetailsModel
          onClose={handleClose}
          handleConfirmation={() => {
            setOpen(false)
            setOpenConfirmation(true)
          }}
          updateListData={(val) => {
            setUpdateData(val)
          }}
          open={open}
          userDetails={userInfo}
        />
      )}
      {openConfirmation && (
        <MobileFormConfirmationModal
          open={openConfirmation}
          handleOk={() => handleMarkClosed()}
          handleClose={() => {
            setOpenConfirmation(false)
            setOpen(true)
          }}
          handleNo={() => {
            setOpenConfirmation(false)
            setOpen(false)
          }}
        />
      )}
      {ticketList && ticketList.data.support.length > 0 ? (
        <>
          <div className="w-full pb-4 overflow-auto">
            <TicketTable
              ticketList={ticketList!}
              onRowClick={(item) => {
                setUserInfo(item)
                handleOpen()
              }}
            />
          </div>

          {ticketList && (
            <CustomPageNavigator
              currentPage={currentPage}
              totalItemCount={ticketList?.data?.count}
              limitPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </>
      ) : (
        <DataUnavailable description="No record found" />
      )}
    </div>
  )
}

export default MobileContactForm
